import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'
import undefsafe from 'undefsafe'

import { StarRating } from '../../pages/search/result/utils'
import AudioPlayerSmallContainer from '../audio/audioPlayerSmallContainer'
import ItemActions from './common/itemActions'
import TrendingItem from './common/trendingItem'

import styles from './gridAudio.module.css'

const ItemCardGridAudio = ({
  item,
  onAddToFavourites,
  rank,
  onAddToCollections,
  onItemLinkClick = () => {},
  onAddToCart = () => {}
}) => {
  const salesLabel = item.number_of_sales === 1 ? 'Sale' : 'Sales'

  const mp3Url = undefsafe(item, 'previews.icon_with_audio_preview.mp3_url')

  return (
    <div className={styles.itemView}>
      <div className={styles.actionContainer}>
        <div>
          <div className={styles.miniAudioPlayerContainer}>
            <AudioPlayerSmallContainer src={mp3Url} />
          </div>
          <a className={styles.thumbnail} href={`${item.url}?s_rank=${rank}`} onClick={onItemLinkClick}>
            {item.trending && <TrendingItem />}
            <img alt={item.name} src={item.ui.smallPreviewUrl} title={item.name} width='80' height='80' className={styles.thumbnailImage} />
          </a>
        </div>
        <ItemActions item={item} onAddToFavourites={onAddToFavourites} onAddToCollections={onAddToCollections} onAddToCart={onAddToCart} />
      </div>

      <h3 className={styles.itemName}>
        <a className='fds-c-text-link -color-inherit -decoration-reversed'
          href={`${item.url}?s_rank=${rank}`} onClick={onItemLinkClick}>{item.name}</a>
      </h3>

      <div>
        { !!item.rating.rating &&
          <StarRating
            rating={item.rating.rating}
            className='star-rating--search' />
        }
      </div>

      <footer className={styles.footer}>
        <p className='fds-c-text-body -size-xs fds-u-m0'>
          {item.number_of_sales} {salesLabel} <span className='product-grid__price'>${item.price}</span>
        </p>
        {item.ui.footerLink && <Link to={item.ui.footerLink.href}>{item.ui.footerLink.label}</Link>}
      </footer>
    </div>
  )
}

ItemCardGridAudio.propTypes = {
  item: PropTypes.object.isRequired,
  onAddToFavourites: PropTypes.func.isRequired,
  rank: PropTypes.number.isRequired,
  onItemLinkClick: PropTypes.func,
  onAddToCart: PropTypes.func
}

export default ItemCardGridAudio



// WEBPACK FOOTER //
// ./client/components/itemCard/gridAudio.js